module.exports = __webpack_public_path__ + "static/img/solution_img_2.94f92d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-h/solution_img_2.png
// module id = 3/vc
// module chunks = 22